export const selectIsPaymentMethodLoading = (state) => state.paymentMethod.loading
